export const grade_rates: { [grade: string]: number } = {
    "standard": 72,
    "premium": 78,
    "vip": 84,
    "vvip": 90
}